// Vendor JS
import Debug from 'debug';
import axios from 'axios';

// CIG JS
import httpBuildQuery from '../../util/http-build-query';
import Cig from '../../util/Cig';

/* eslint-disable no-alert */

class CommentAdmin {
	init() {
		try {
			Debug(`cig:info:sage:class:CommentAdmin`)(`init start`);
			this.addAllHandlers();

		} catch (err) {
			Debug(`cig:error:sage:class:CommentAdmin`)(`init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}

	/**
	 * Comment delete link event handler, ban user and remove comment
	 *
	 * @param event
	 *
	 * @return {Promise<boolean>}
	 */
	deleteLinkHandler = async event => {
		try {
			event.preventDefault();

			const el = event.target || event.srcElement;
			const id = el.getAttribute('data-id');

			if (id && confirm('Delete comment?')) {

				const deleteResponse = await axios.post(`/wp-ajax/?`,
					httpBuildQuery({
						action: `cig_comment_moderation`,
						comment_action: `delete`,
						id,
					}));

				// Get the data property of the response
				const { data } = deleteResponse || {};

				// No error, user has been banned, remove comment
				if (data) {
					document.querySelector(`#comment-${id}`).remove();
				} else {
					alert(`Unable to ban delete comment`);
				}
			}

		} catch (err) {
			Debug(`cig:error:sage:class:CommentAdmin`)(`deleteLinkHandler Error: %s %o`, err.message, err);
			alert(err); // TODO: should this happen?
			throw new Error(err);
		}

		return false;
	};

	/**
	 * Add delete link event handlers
	 */
	addDeleteLinkHandlers = () => {
		try {
			Array.from(document.querySelectorAll('.comment-moderation-delete'))
				.forEach(link => link.addEventListener('click', this.deleteLinkHandler));

		} catch (err) {
			Debug(`cig:error:sage:class:CommentAdmin`)(`addDeleteLinkHandlers Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * Ban link event handler
	 *
	 * @param event
	 *
	 * @return {Promise<boolean>}
	 */
	banLinkHandler = async event => {
		try {
			event.preventDefault();

			const el = event.target || event.srcElement;
			const id = el.getAttribute('data-id');

			if (id && confirm('Delete comment & Ban user?')) {

				// Attempt to ban the user
				const banResponse = await axios.post(`/wp-ajax/?`,
					httpBuildQuery({
						action: `cig_comment_moderation`,
						comment_action: `ban`,
						id
					}));

				// Get the data property of the response
				const { data } = banResponse || {};

				// No error, user has been banned, remove comment
				if (data) {
					document.querySelector(`#comment-${id}`).remove();
				} else {
					alert('Unable to ban user');
				}
			}
		} catch (err) {
			Debug(`cig:error:sage:class:CommentAdmin`)(`banLinkHandler Error: %s %o`, err.message, err);
			throw new Error(err);
		}

		return false;
	};

	/**
	 * Add ban link event handlers
	 */
	addBanLinkHandlers = () => {
		try {
			Array.from(document.querySelectorAll('.comment-moderation-ban'))
				.forEach(link => link.addEventListener('click', this.banLinkHandler));

		} catch (err) {
			Debug(`cig:error:sage:class:CommentAdmin`)(`addBanLinkHandlers Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * IP link handler, copy author IP address to clipboard
	 *
	 * @param event
	 */
	ipLinkHandler = event => {
		const ip = event.target.nodeName === 'A' ? event.target.querySelector('.ip-address') : event.target;

		if (ip) {
			Cig.copyToClipboardNoInputElement(ip);
		}
	};

	/**
	 * Add IP link event handlers
	 */
	addIpLinkHandlers = () => {
		try {
			Array.from(document.querySelectorAll('.comment-moderation-ip'))
				.forEach(link => link.addEventListener('click', this.ipLinkHandler));

		} catch (err) {
			Debug(`cig:error:sage:class:CommentAdmin`)(`addIpLinkHandlers Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	};

	/**
	 * Add all Event Listeners
	 */
	addAllHandlers = () => {
		this.addDeleteLinkHandlers();
		this.addBanLinkHandlers();
		this.addIpLinkHandlers();
	};
}

export default new CommentAdmin();
